document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('#recently-viewed-products');
  const wrapper = document.querySelector('#recently-viewed-wrapper');

  if (!container || !wrapper) return;

  function getSearchQueryString() {
    let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

    // Most recent first
    items = items.reverse();

    // Remove current product on product page
    if (window.meta && meta.product && meta.product.id) {
      const currentProductId = String(meta.product.id);
      items = items.filter(id => String(id) !== currentProductId);
    }

    return items.map(id => `id:${id}`).join(' OR ');
  }

  function fetchProducts() {
    const queryString = getSearchQueryString();
    if (!queryString) return;

    fetch(
      `${document.documentElement.lang === "ar" ? "/ar" : ""}/search?view=recently-viewed-products&type=product&q=${encodeURIComponent(queryString)}`,
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const section = tempDiv.querySelector('.recentView');
      if (section) {
        const ids = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]').reverse();
        const currentId = window.meta?.product?.id;
        const orderedIds = ids.filter(id => String(id) !== String(currentId));
        const cards = [...section.children];
        cards.sort((a, b) => {
          const aId = orderedIds.indexOf(Number(a.dataset.productId) || a.dataset.productId);
          const bId = orderedIds.indexOf(Number(b.dataset.productId) || b.dataset.productId);
          return aId - bId;
        });

      container.innerHTML = '';
      cards.forEach(card => container.appendChild(card));
        wrapper.style.display = 'block';
            var swiperGrid = new Swiper(".mySwiper-recentview", {
    
    slidesPerView: 4.5,
    slidesPerGroup: 4.5,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320:{
        slidesPerView: 2.4,
        slidesPerGroup: 1,
        spaceBetween: 15,
        freeMode: true,
      },
      750: {
        slidesPerView: 4.5,
        slidesPerGroup: 1,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 4.5,
        slidesPerGroup: 4,
      }
    }
  });
      }
    })
    .catch(console.error);
  }

  fetchProducts();
});